import React from 'react';
import { withAuthenticationRequired } from '@auth0/auth0-react';
import useTranslationLgs from '@hooks/i18n/useTranslation.tsx';
import ResponsiveLayout from '@app/layout/ResponsiveLayout.tsx';
import { ResponsiveSupplierNotificationList } from '@app/pages/customer/supplier-notification/ResponsiveSupplierNotificationList.tsx';
import { PermissionTypesEnum } from '@api/ringil-api.v2.tsx';

interface ComponentProps {}

const SupplierNotificationListPage: React.FC<ComponentProps> = () => {
  const { tr } = useTranslationLgs();
  return (
    <>
      <ResponsiveLayout
        title={tr(`create-shipment.SupplierNotificationListPage`, `Supplier notification list`)}
        oneOfPermission={[PermissionTypesEnum.PERMISSION_SN_LIST_READ, PermissionTypesEnum.PERMISSION_SN_LIST_RW]}
      >
        <ResponsiveSupplierNotificationList />
      </ResponsiveLayout>
    </>
  );
};

export default withAuthenticationRequired(SupplierNotificationListPage);
